import $http from '../../../axios-instance';
import Swal from "sweetalert2";

/**
 * Actualizar información de generales banner
 */
export async function actualizarConfiguracionBanner({state, dispatch,commit}) {

  commit('dashboard/load', true, {root:true});

  await $http.post(`/empresas/configuracion-banners/${state.empresa.id}`, state.empresa)
    .then(async (response) => {
      commit('dashboard/load', false, {root:true});
      await dispatch('mostrarMensaje', {icono: 'success', mensaje: response.data.message});
    })
    .catch(async (error) => {
      commit('dashboard/load', false, {root:true});
      await dispatch('mostrarMensaje', {icono: 'error', mensaje: error.message});
    });
}

export async function mostrarMensaje({}, {icono, mensaje}) {

  const titulo = icono === 'success' ? 'Muy bien!' : 'Error';

  await Swal.fire({
    position: 'center',
    icon: icono,
    title: titulo,
    text: mensaje,
    showConfirmButton: true,
    timer: 5000
  });
}
